import { render, staticRenderFns } from "./DepartamentoField.vue?vue&type=template&id=0b1bd2fa&scoped=true&"
import script from "./DepartamentoField.vue?vue&type=script&lang=js&"
export * from "./DepartamentoField.vue?vue&type=script&lang=js&"
import style0 from "./DepartamentoField.vue?vue&type=style&index=0&id=0b1bd2fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1bd2fa",
  null
  
)

export default component.exports